import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	reorderParticipantNonfinal: {
		id: 'standups.participant.item.reorder-participant-nonfinal',
		defaultMessage: 'Reorder participant',
		description: 'Tooltip text for reordering a user in stand-up',
	},
});
